export default "__VITE_ASSET__2c973563__"